@if (employeeSettings$ | async) {
  <div *flexyooLet="employeeSettings$ | async as employeeSettings" class="document-signing-pane">
    @if (shouldSignCafeteriaAgreement$ | async) {
      <div
        *flexyooLet="isSelectedTypeSigned$ | async as isSelectedTypeSigned"
        class="agreement-sign-cards"
      >
        <mat-card appearance="outlined" class="agreement-sign-card">
          <mat-card-title class="agreement-sign-card__title">
            <mat-icon svgIcon="fo-cafeteria-plan"></mat-icon>
            {{ 'financing-plans.cafeteria-plan' | translate }}
          </mat-card-title>
          <mat-card-content
            *flexyooLet="areBothPlansEnabled$ | async as areBothPlansEnabled"
            [formGroup]="form"
          >
            <div *flexyooLet="isFirstLogin$ | async as isFirstLogin" class="plan-description">
              @if (areBothPlansEnabled) {
                @if (isFirstLogin) {
                  <span>
                    {{ 'user-agreement-sign-page.multi-plans.first-login-description' | translate }}
                  </span>
                } @else {
                  <span>
                    {{ 'user-agreement-sign-page.multi-plans.description.p1' | translate }}
                  </span>
                  <span>
                    {{ 'user-agreement-sign-page.multi-plans.description.p2' | translate }}
                  </span>
                  <span>
                    {{ 'user-agreement-sign-page.multi-plans.description.p3' | translate }}
                  </span>
                }
              } @else {
                <span>
                  {{
                    'user-agreement-sign-page.single-plan.' +
                      (isFirstLogin ? 'first-login-description' : 'description') | translate
                  }}
                </span>
              }
            </div>
            @if (areBothPlansEnabled) {
              <app-user-agreement-type-selection
                class="user-agreement-type-selection"
                formControlName="userAgreementType"
              ></app-user-agreement-type-selection>
            }
          </mat-card-content>
          <mat-card-actions>
            <div class="actions-block">
              <button
                matButton="filled"
                [disabled]="isSelectedTypeSigned || form.invalid"
                (click)="userRequestedCafeteriaSign$.next(true)" class="fo-color-secondary"
              >
                {{ 'general.sign' | translate }}
              </button>
              <span>
                {{ 'general.status' | translate }}:
                {{
                  'user-agreement-sign-page.status.' +
                    (isSelectedTypeSigned ? 'signed' : 'not-signed') | translate
                }}
              </span>
            </div>
          </mat-card-actions>
        </mat-card>
        @if (isSignBlockShown$ | async) {
          <mat-card appearance="outlined" class="agreement-sign-card">
            <mat-card-content>
              <div>
                @let selectedType = selectedCafeteriaUserAgreementType();
                @if (showQuillSignatureType$ | async) {
                  @if (selectedType !== null) {
                    <app-user-agreement-sign
                      quillSignContext="cafeteria"
                      [userAgreementType]="selectedType"
                    ></app-user-agreement-sign>
                  }
                }
                @if (showManualSignatureType$ | async) {
                  @if (selectedType !== null) {
                    <app-user-agreement-sign-upload-block
                      [isQuillSignPossible]="showQuillSignatureType$ | async"
                      [userAgreementType]="selectedType"
                    ></app-user-agreement-sign-upload-block>
                  }
                }
              </div>
            </mat-card-content>
          </mat-card>
        }
      </div>
    }

    @if (shouldSignMobilityBudgetAgreement$ | async) {
      <div
        *flexyooLet="isMobilitySelectedTypeSigned$ | async as isMobilitySelectedTypeSigned"
        class="agreement-sign-cards"
      >
        <mat-card appearance="outlined" class="agreement-sign-card">
          <mat-card-title class="agreement-sign-card__title">
            <mat-icon>directions_car</mat-icon>
            {{ 'financing-plans.mobility-budget' | translate }}
          </mat-card-title>
          <mat-card-content>
            <div
              *flexyooLet="isMobilityFirstLogin$ | async as isMobilityFirstLogin"
              class="plan-description"
            >
              <span>
                {{
                  (isMobilityFirstLogin
                    ? 'user-agreement-sign-page.mobility-budget.description'
                    : 'user-agreement-sign-page.single-plan.description'
                  ) | translate
                }}
              </span>
            </div>
          </mat-card-content>
          <mat-card-actions>
            <div class="actions-block">
              <button
                matButton="filled"
                type="button"
                [disabled]="isMobilitySelectedTypeSigned"
                (click)="userRequestedMobilitySign$.next(true)" class="fo-color-secondary"
              >
                {{ 'general.sign' | translate }}
              </button>
              <span>
                {{ 'general.status' | translate }}:
                {{
                  'user-agreement-sign-page.status.' +
                    (isMobilitySelectedTypeSigned ? 'signed' : 'not-signed') | translate
                }}
              </span>
            </div>
          </mat-card-actions>
        </mat-card>
        @if (isMobilityPhoneStepShown$ | async) {
          <mat-card appearance="outlined" class="agreement-sign-card">
            <mat-card-content>
              <app-mobility-budget-phone-step
                [savedPhoneNumber]="savedMobilePhoneNumber$ | async"
                (confirmed)="onMobilityPhoneConfirmed()"
              ></app-mobility-budget-phone-step>
            </mat-card-content>
          </mat-card>
        }
        @if (isMobilityAgreementSignBlockShown$ | async) {
          <mat-card appearance="outlined" class="agreement-sign-card">
            <mat-card-content>
              <div>
                @if (showQuillSignatureType$ | async) {
                  <app-user-agreement-sign
                    quillSignContext="mobility-budget"
                    [userAgreementType]="UserAgreementType.MobilityBudget"
                  ></app-user-agreement-sign>
                }
                @if (showManualSignatureType$ | async) {
                  <app-user-agreement-sign-upload-block
                    [isQuillSignPossible]="showQuillSignatureType$ | async"
                    [userAgreementType]="UserAgreementType.MobilityBudget"
                  ></app-user-agreement-sign-upload-block>
                }
              </div>
            </mat-card-content>
          </mat-card>
        }
      </div>
    }
  </div>
}
